"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataGridNewCellTextWrapId = void 0;
exports.dataGridNewCellTextWrapId = 'grid-text-wrap';
//# sourceMappingURL=contants.js.map